module.exports = __webpack_public_path__ + "static/img/2-0.832d0ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/user-center/my-focus/2-0.jpg
// module id = nHHZ
// module chunks = 1